import { render, staticRenderFns } from "./options.vue?vue&type=template&id=3ff420d1&scoped=true"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"
import style0 from "./options.vue?vue&type=style&index=0&id=3ff420d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff420d1",
  null
  
)

export default component.exports